<template>
    <div class="number-selector input-group">
        <button class="btn btn-outline-gray" :class="{'disabled': content === min}" type="button" @click="content--">
            <span class="bi bi-dash"></span>
        </button>
        <div class="value">
            <input v-model="content" type="text" aria-label="Count" readonly>
            <span v-if="itemTitle">{{ itemTitle }}</span>
        </div>
        <button class="btn btn-outline-gray" :class="{'disabled': content === max}" type="button" @click="content++">
            <span class="bi bi-plus"></span>
        </button>
    </div>
</template>

<script>
export default {
    name: "NumberSelector",
    props: {
        value: {
            type: Number,
            default: 0
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 30
        },
        itemTitle: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            content: this.value
        }
    },
    watch: {
        content: function (newVal, oldVal) {
            if (newVal >= this.min && newVal <= this.max) {
                this.$emit('input', newVal);
            } else {
                this.content = oldVal;
            }
        },
        min: function (newVal, oldVal) {
            if (newVal >= this.max) this.min = oldVal;
            if (newVal > this.content) {
                this.content = newVal;
            }
        },
        max: function (newVal, oldVal) {
            if (newVal <= this.min) this.max = oldVal;
            if (newVal < this.content) {
                this.content = newVal;
            }
        }
    },
}
</script>

<style scoped>

</style>
